import React from 'react';
import { DropdownContext, IDropdownBaseProps } from './DropdownContext';

export type StyleIdentifier = 'default' | 'mobile' | 'compact';

export const useDropdown = (args: IDropdownBaseProps) => {
  let props = React.useContext(DropdownContext);

  if (args.isMobile !== undefined || args.isTablet !== undefined) {
    props = args;
  }

  const styleIdentifier: StyleIdentifier = props.isMobile || props.isTablet || props.asMenu ? 'mobile' : 'default';

  return { ...props, styleIdentifier };
};
